// Branding podle domény. Aplikace je JEDEN Pages projekt (jedna DB, jedny
// účty), ale běží na víc doménách — na každé se tváří jako samostatný nástroj.
//
// tools.v-martsystem.cz  → V-Mart Tools (celý rozcestník)
// vyroba.v-martsystem.cz → V-Mart Výroba (jen výrobní modul)
//
// Přidání další domény = přidat větev sem + CORS origin v api/index.ts.

export type BrandId = 'tools' | 'vyroba';

export type Brand = {
  id: BrandId;
  /** Název v sidebaru a v <title>. */
  name: string;
  /** Doména pod názvem v sidebaru. */
  domain: string;
  /** Kam vede logo / kořenová route. */
  homePath: string;
};

const BRANDS: Record<BrandId, Brand> = {
  tools: {
    id: 'tools',
    name: 'V-Mart Tools',
    domain: 'tools.v-martsystem.cz',
    homePath: '/',
  },
  vyroba: {
    id: 'vyroba',
    name: 'V-Mart Výroba',
    domain: 'vyroba.v-martsystem.cz',
    homePath: '/vyroba',
  },
};

/**
 * Vrátí brand podle aktuálního hostname. Na localhpart se dá brand vynutit
 * query parametrem `?brand=vyroba`, ať se dá lokálně testovat bez hosts
 * souboru; v produkci se query ignoruje (hostname vyhrává).
 */
export function detectBrand(): Brand {
  const host = window.location.hostname;
  if (host.startsWith('vyroba.') || host.startsWith('vyroba-dev.')) {
    return BRANDS.vyroba;
  }
  if (host === 'localhost' || host === '127.0.0.1') {
    const forced = new URLSearchParams(window.location.search).get('brand');
    if (forced === 'vyroba') return BRANDS.vyroba;
  }
  return BRANDS.tools;
}
